import React from 'react';

function Terms() {
  return (
    <div className="legal-page">
      <h1>Terms & Conditions</h1>
      <p className="updated">Last Updated: November 28, 2025</p>

      <p>
        Welcome to Little Avalon. These Terms and Conditions ("Terms") govern your use of 
        our mobile application and website (collectively, the "Service"). By using our 
        Service, you agree to be bound by these Terms.
      </p>

      <h2>1. Use of Service</h2>
      <p>
        You must be at least 13 years old to use our Service. By using the Service, you 
        represent that you are at least 13 years old and have the legal capacity to enter 
        into these Terms.
      </p>
      <p>
        You agree to use the Service only for lawful purposes and in accordance with these 
        Terms. You are responsible for maintaining the confidentiality of your account 
        credentials.
      </p>

      <h2>2. Account Registration</h2>
      <p>
        To access certain features, you may need to create an account. You agree to provide 
        accurate, current, and complete information during registration and to update such 
        information to keep it accurate.
      </p>
      <p>
        You are responsible for all activities that occur under your account. Notify us 
        immediately of any unauthorized use of your account.
      </p>

      <h2>3. Orders and Payment</h2>
      <p>
        When you place an order through our Service, you agree to pay the total amount 
        shown, including food items, taxes, delivery fees, and any applicable tips.
      </p>
      <ul>
        <li>All prices are in US Dollars and are subject to change without notice.</li>
        <li>Payment is processed at the time of order through our secure payment system.</li>
        <li>We reserve the right to refuse or cancel any order for any reason.</li>
        <li>Menu items and availability may vary by location.</li>
      </ul>

      <h2>4. Delivery Services</h2>
      <p>
        Delivery services may be provided by Little Avalon or third-party delivery partners 
        (such as DoorDash). Delivery times are estimates and not guaranteed.
      </p>
      <ul>
        <li>You must provide an accurate delivery address and be available to receive your order.</li>
        <li>Delivery is available within our designated service areas only.</li>
        <li>We are not responsible for delays caused by factors outside our control (traffic, weather, etc.).</li>
      </ul>

      <h2>5. Rewards Program</h2>
      <p>
        Our rewards program allows you to earn points on qualifying purchases. Points and 
        rewards are subject to the following:
      </p>
      <ul>
        <li>Points have no cash value and cannot be transferred or sold.</li>
        <li>We reserve the right to modify or terminate the rewards program at any time.</li>
        <li>Fraudulent activity may result in forfeiture of points and account termination.</li>
        <li>Rewards must be redeemed through the Service and cannot be combined with certain promotions.</li>
      </ul>

      <h2>6. Cancellations and Refunds</h2>
      <p>
        Once an order is submitted, it may not be possible to cancel. Refund eligibility 
        depends on the circumstances:
      </p>
      <ul>
        <li>Contact us immediately if there's an issue with your order.</li>
        <li>Refunds for quality issues are handled on a case-by-case basis.</li>
        <li>We reserve the right to refuse refunds for orders that were delivered as requested.</li>
      </ul>

      <h2>7. Intellectual Property</h2>
      <p>
        The Service and its content, including but not limited to text, graphics, logos, 
        and software, are owned by Little Avalon and are protected by intellectual property 
        laws. You may not copy, modify, distribute, or create derivative works without our 
        written permission.
      </p>

      <h2>8. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for any unlawful purpose</li>
        <li>Attempt to gain unauthorized access to any part of the Service</li>
        <li>Interfere with or disrupt the Service</li>
        <li>Submit false information or impersonate others</li>
        <li>Use automated systems to access the Service without permission</li>
      </ul>

      <h2>9. Disclaimer of Warranties</h2>
      <p>
        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, 
        EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED, 
        ERROR-FREE, OR SECURE.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, LITTLE AVALON SHALL NOT BE LIABLE FOR ANY 
        INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR 
        USE OF THE SERVICE. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID FOR 
        THE ORDER GIVING RISE TO THE CLAIM.
      </p>

      <h2>11. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Little Avalon, its officers, directors, 
        employees, and agents from any claims, damages, or expenses arising from your use 
        of the Service or violation of these Terms.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with the laws of the 
        State of Nevada, without regard to its conflict of law provisions. Any disputes 
        shall be resolved in the courts located in Clark County, Nevada.
      </p>

      <h2>13. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. We will notify you of material changes 
        by posting the updated Terms on the Service. Your continued use of the Service after 
        changes constitutes acceptance of the new Terms.
      </p>

      <h2>14. Contact Us</h2>
      <p>
        If you have questions about these Terms, please contact us at:
      </p>
      <p>
        <strong>Little Avalon</strong><br />
        9410 W Sahara Ave Ste 130<br />
        Las Vegas, NV 89117<br />
        Phone: (702) 462-9252<br />
        Email: support@littleavalon.com
      </p>
    </div>
  );
}

export default Terms;
